// import axios from 'src/utils/axios';

export const sendSubscriptionToPushServer = userSubscription => {

    // return axios.post('/PushNotification/Subscribe', userSubscription);
};
export const getNotifications = () => {
    // return axios.get('/PushNotification');
};
export const notifyNotificationViewed = id => {
    // return axios.delete(`/PushNotification/${id}`);
};
